import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import vuetify from './plugins/vuetify';
import IntersectionDirective from './assets/js/intersectionDirective'


Vue.config.productionTip = false


new Vue({
    router,
    store,
    vuetify,
    render: h => h(App)
}).$mount('#app')


export const ScrollDirective = {
    inserted: function (el, binding) {
        let f = function (evt) {
            if (binding.value(evt, el)) {
                window.removeEventListener('scroll', f)
            }
        }
        window.addEventListener('scroll', f)
    }
}

// You can also make it available globally.
Vue.directive("scroll", ScrollDirective);
Vue.directive("intersect", IntersectionDirective);
